class TryStripe {
    constructor() {
        this.initTryStripe();
    }
    initTryStripe(){
        let thisClass = this;
        $('.try-stripe').on('click', function (e) {
            let organizationID = e.currentTarget.getAttribute('data-value');
            //get last 4 digits of card
            $.ajax({
                url: '?do=getRetryPaymentData&organizationID='+organizationID,
                type: 'GET',
                dataType: '',
                data: {}
            }).done(function(data) {
                if(data)
                    thisClass.swalFire(data, organizationID);
            });

        });
    }
    swalFire(data, organizationID){
        Swal.fire({
            html: ` <h4 class="text-center text-primary">`+data.organizationName+`</h4>
                    <span class="text-primary">Retry Payment for card - `+data.subscriptionDetails.subscription_info+`</span>`,
            icon: "warning",
            iconColor: "#FF5206",
            buttonsStyling: false,
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonText: "Retry",
            customClass: {
                confirmButton: "btn btn-danger mt-0",
                cancelButton: 'btn btn-light-primary mt-0',
            },
            showLoaderOnConfirm: true,
            returnFocus: false,
            allowOutsideClick: () => !Swal.isLoading(),
            allowEscapeKey: () => !Swal.isLoading(),
            preConfirm: () => {
                return fetch('/payments?do=tryToChargeStripe&organizationID='+organizationID)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(response.statusText)
                        }
                        return response.json();
                    }).catch(error => {
                        Swal.showValidationMessage(`Request failed: ${error}`)
                    });
            },
        }).then((result) => {
            console.log(result);
            if(result.value.type === 'error'){
                Swal.fire({
                    html: ` <h4 class="text-center text-primary">An error occurred while trying to confirm your payment</h4>
                                <span class="text-center text-primary">${result.value.value}</span>`,
                    icon: "error",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    showCancelButton: false,
                    confirmButtonText: "Close",
                    customClass: {
                        confirmButton: "btn btn-light-primary mt-0"
                    },
                });
            }
            else if(result.isConfirmed){
                Swal.fire({
                    html: ` <h4 class="text-center text-primary">Payment has been successfully processed</h4>
                            <span class="text-center text-primary">Check your e-mail address for further information.</span>`,
                    icon: "success",
                    iconColor: "#36B37E",
                    buttonsStyling: false,
                    showCancelButton: false,
                    confirmButtonText: "Close",
                    customClass: {
                        confirmButton: "btn btn-light-primary mt-0"
                    },
                    willClose: () => {
                        //wait for 1 sec before reload
                        setTimeout(() => {
                            location.reload();
                        }, 1000);
                    }
                });
            }
        });
    }
}
window.TryStripe = TryStripe;